import BigPopupTemplate from "components/templates/modal/big/BigPopupTemplate";
import React from "react";
import {
  FIRMWARE_UPGRADE_STATUS,
  FirmwareUpdateInfoResult,
  FIRMWARE_UPDATE_STEP,
} from "api/interfaces/settingsInterface.interface";
import { RELEASE_NOTE_TYPE } from "utils/firmwareUtil";
import FirmwareIntro from "./step/FirmwareIntro";
import FirmwareUpdate from "./step/FirmwareUpdate";
import FirmwareFailed from "./step/FirmwareFailed";
import FirmwareSuccess from "./step/FirmwareSuccess";
import ReleaseNote from "./modal/ReleaseNote";
import Spinner from "components/atoms/loader/Spinner";
import NormalConfirmModal from "components/templates/modal/small/confirm/normal";
import * as s from "pages/recorders/RecordersStyled";
interface Props {
  data: FirmwareUpdateInfoResult | null;
  step: FIRMWARE_UPDATE_STEP;
  percent: number;
  onClickCancel: () => void;
  onClickManageAutoUpdate: () => void;
  onClickUpdate: () => void;
  showReleaseNote:
    | typeof RELEASE_NOTE_TYPE[keyof typeof RELEASE_NOTE_TYPE]
    | null;
  onModal: (
    type: typeof RELEASE_NOTE_TYPE[keyof typeof RELEASE_NOTE_TYPE]
  ) => void;
  uploadStep: FIRMWARE_UPGRADE_STATUS;
  isLoadingUpdate: boolean;
  failedReason: string;
  disabledUpdate: boolean;
  onlineStatus: boolean;
  showConfirmModal: boolean;
  onConfirmModal: () => void;
  autoUpdate: boolean;
}
export default function UpdateFirmwarePresenter({
  data,
  autoUpdate,
  onClickCancel,
  onClickManageAutoUpdate,
  onClickUpdate,
  step,
  percent,
  showReleaseNote,
  onModal,
  uploadStep,
  isLoadingUpdate,
  failedReason,
  disabledUpdate,
  onlineStatus,
  showConfirmModal,
  onConfirmModal,
}: Props) {
  if (!data) return <Spinner />;
  return (
    <BigPopupTemplate
      title="Firmware Update"
      onModal={onClickCancel}
    >
      {step === FIRMWARE_UPDATE_STEP.INTRO && (
        <FirmwareIntro
          data={data}
          onClickManageAutoUpdate={onClickManageAutoUpdate}
          onClickUpdate={onConfirmModal}
          onClickCancel={onClickCancel}
          onModal={onModal}
          isLoadingUpdate={isLoadingUpdate}
          disabledUpdate={disabledUpdate}
          autoUpdate={autoUpdate}
        />
      )}
      {step === FIRMWARE_UPDATE_STEP.UPDATE && (
        <FirmwareUpdate
          data={data}
          percent={percent}
          onClickCancel={onClickCancel}
          uploadStep={uploadStep}
        />
      )}
      {step === FIRMWARE_UPDATE_STEP.FAILED && (
        <FirmwareFailed
          data={data}
          percent={percent}
          onClickCancel={onClickCancel}
          onClickUpdate={onClickUpdate}
          failedReason={failedReason}
          disabledUpdate={disabledUpdate}
          onlineStatus={onlineStatus}
        />
      )}
      {step === FIRMWARE_UPDATE_STEP.SUCCESS && (
        <FirmwareSuccess
          data={data}
          percent={percent}
          onClickCancel={onClickCancel}
        />
      )}
      {showReleaseNote && (
        <ReleaseNote
          onClickCancel={() => onModal(showReleaseNote)}
          releaseNote={data[showReleaseNote]}
        />
      )}
      {showConfirmModal && (
        <NormalConfirmModal
          onConfirmCancel={onConfirmModal}
          onConfirm={onClickUpdate}
          confirmLabel="Update"
          cancelLabel="Cancel"
        >
          <s.UpdateFirmwareStyled.ConfirmModal>
            <p>Are you sure you want to update the firmware?</p>
            <p>
              <b>
                This operation will take approximately 10 minutes
                <br /> and cannot be undone.
              </b>
              <br />
              Would you like to continue?
            </p>
          </s.UpdateFirmwareStyled.ConfirmModal>
        </NormalConfirmModal>
      )}
    </BigPopupTemplate>
  );
}
